import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import StringResourceManager, { GetString } from '../StringResourceManager';
import React from 'react';
import NodeSelection from '../NodeSelection';
import {
  SendToDivisionCommandInfo,
  SendToLanesCommandInfo,
  SendToNodeGroupsCommandInfo,
  SendToSiteNumbersCommandInfo,
} from '../../Interfaces/Commands/CommandInfo';
import {
  sendScheduledToDivisionCommand,
  sendScheduledToLanesCommand,
  sendScheduledToNodeGroupsCommand,
  sendScheduledToSiteNumberCommand,
} from '../../store/Assets/AssetsActions';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { Button } from '@progress/kendo-react-buttons';
import {
  SendToDivisionsScheduledCommandInfo,
  SendToLanesScheduledCommandInfo,
  SendToNodeGroupsScheduledCommandInfo,
  SendToSiteNumbersScheduledCommandInfo,
} from '../../Interfaces/Commands/ScheduledCommandInfo';

interface Props {
  commandName: string;
  title: string;
  handleCloseDialog: (open: boolean) => void;
  displayCommandSendNotification: (display: boolean) => void;
  parameters: string;
  startDate: string | null;
  endDate: string | null;
  cronFrequency: string;
}

const ScheduledCommandNodeSelectionDialog: React.FC<Props> = ({
  commandName,
  title,
  handleCloseDialog,
  displayCommandSendNotification,
  parameters,
  startDate,
  endDate,
  cronFrequency,
}): React.ReactElement => {
  const dispatch: Dispatch<any> = useDispatch();

  const handleClose = () => {
    handleCloseDialog(false);
  };
  const cancelOnClick = () => {
    handleCloseDialog(false);
  };

  const setSendToSiteNumberCommand = (
    command: SendToSiteNumbersCommandInfo
  ) => {
    let scheduledCommandInfo: SendToSiteNumbersScheduledCommandInfo = {
      Division: command.Division,
      SiteNumbers: command.SiteNumbers,
      CommandInfo: {
        Command: command.CommandInfo.Command,
        StartDate: startDate,
        EndDate: endDate,
        CronFrequency: cronFrequency,
        Parameters: parameters,
      },
    };
    sendScheduledToSiteNumberCommand(dispatch, scheduledCommandInfo);
    displayCommandSendNotification(true);
    handleClose();
  };

  const setSendToNodeGroupsCommand = (command: SendToNodeGroupsCommandInfo) => {
    let scheduledCommandInfo: SendToNodeGroupsScheduledCommandInfo = {
      Division: command.Division,
      SiteNumber: command.SiteNumber,
      NodeGroups: command.NodeGroups,
      CommandInfo: {
        Command: command.CommandInfo.Command,
        StartDate: startDate,
        EndDate: endDate,
        CronFrequency: cronFrequency,
        Parameters: parameters,
      },
    };

    sendScheduledToNodeGroupsCommand(dispatch, scheduledCommandInfo);
    displayCommandSendNotification(true);
    handleClose();
  };

  const setSendToLanesCommand = (command: SendToLanesCommandInfo) => {
    let scheduledCommandInfo: SendToLanesScheduledCommandInfo = {
      Division: command.Division,
      SiteNumber: command.SiteNumber,
      NodeGroup: command.NodeGroup,
      LaneNumbers: command.LaneNumbers,
      CommandInfo: {
        Command: command.CommandInfo.Command,
        StartDate: startDate,
        EndDate: endDate,
        CronFrequency: cronFrequency,
        Parameters: parameters,
      },
    };

    sendScheduledToLanesCommand(dispatch, scheduledCommandInfo);
    displayCommandSendNotification(true);
    handleClose();
  };

  const setSendToDivisionCommand = (command: SendToDivisionCommandInfo) => {
    let scheduledCommandInfo: SendToDivisionsScheduledCommandInfo = {
      Divisions: command.Divisions,
      CommandInfo: {
        Command: command.CommandInfo.Command,
        StartDate: startDate,
        EndDate: endDate,
        CronFrequency: cronFrequency,
        Parameters: parameters,
      },
    };

    sendScheduledToDivisionCommand(dispatch, scheduledCommandInfo);
    displayCommandSendNotification(true);
    handleClose();
  };

  return (
    <>
      <Dialog
        style={{ zIndex: 10000 }}
        height="65vh"
        minWidth="55vw"
        title={
          <StringResourceManager
            variant="body1"
            style="commandLabel"
            stringKey={title}
            gutterBottom={true}
          />
        }
        onClose={handleClose}
      >
        <NodeSelection
          command={commandName}
          commandDropdownlistEnable={false}
          setSendToSiteNumberCommand={setSendToSiteNumberCommand}
          setSendToNodeGroupsCommand={setSendToNodeGroupsCommand}
          setSendToLanesCommand={setSendToLanesCommand}
          buttonTitleKey="SEND_REQUEST_STR"
          setSendToDivisionCommand={setSendToDivisionCommand}
        />
        <DialogActionsBar layout="center">
          <Button
            themeColor="primary"
            style={{ width: 100 }}
            onClick={cancelOnClick}
          >
            {GetString('CANCEL_BUTTON')}
          </Button>
        </DialogActionsBar>
      </Dialog>
    </>
  );
};

export default ScheduledCommandNodeSelectionDialog;
